import $ from 'jquery';
export const attachShowHidePasswordHandler = ({ viewId, hideId, inputPasswordSelector = '#password', }) => {
    const $viewBtn = $(viewId);
    const $hideBtn = $(hideId);
    return $viewBtn.add($hideBtn).on('click', () => {
        $(`${inputPasswordSelector}`).each(function (_, element) {
            const $input = $(element);
            const currentPasswordText = $input.val();
            if ($input.attr('type') === 'password') {
                $input.attr('type', 'text').val(currentPasswordText);
                $hideBtn.css({ display: 'block' });
                $viewBtn.css({ display: 'none' });
                $hideBtn.focus();
            }
            else {
                $input.attr('type', 'password').val(currentPasswordText);
                $hideBtn.css({ display: 'none' });
                $viewBtn.css({ display: 'block' });
                $viewBtn.focus();
            }
        });
    });
};
